module.exports = __webpack_public_path__ + "media/shipin.f94a66b4.mp4";